<script>
export default {
  props: ["field", "processField"],
  name: "checkout-field",
  computed: {
    identifier: function() {
      return this.field.path.join("_");
    },
    value: {
      get() {
        return this.field.value;
      },
      set(value) {
        this.$store.dispatch("updateField", {
          field: this.field,
          newProps: { value: value }
        });
      }
    }
  },
  methods: {
    validate: function() {
      this.$store.dispatch("validateField", {
        field: this.field
      });
    }
  }
};
</script>
